import React, {Component} from 'react';
import PropTypes from 'prop-types';

class AccordionItemCarrier extends Component {

    static propTypes = {
        title: PropTypes.object.isRequired,
    };

    render() {
        return null;
    }
}

export default AccordionItemCarrier;